import { Component, Input } from '@angular/core';
import { FormatPricePipe } from "../../pipes/formatPrice.pipe";
import { DataSharingService } from 'src/app/services/data-sharing.service';

@Component({
  selector: 'app-currency-column-molecule',
  templateUrl: './currency-column-molecule.component.html',
  styleUrls: ['./currency-column-molecule.component.scss']
})
export class CurrencyColumnMoleculeComponent {
  @Input() data: any;
  @Input() header: any;
  @Input() readOnlyMode: any;
  editedData: any[] = [];

  constructor(private dataSharingService: DataSharingService){}

  ngOnInit(){
    this.dataSharingService.editedData$.subscribe(data => {
      this.editedData = data;
    });
  }

  selectText(event: FocusEvent): void {
    const inputElement = event.target as HTMLInputElement;
    inputElement.select();
  }
  onCellEdit(event: any, field: string, row: any) {
    if (!row._editedFields) {
      row._editedFields = {};
    }

    row._editedFields[field] = true;
    const editedRow = this.editedData.find(item => item.id === row.id);
    // var position = this.grid.element.querySelectorAll('.e-movablecontent')[0].scrollLeft || 0;
    var position = this.dataSharingService.getGridPosition();

    if (editedRow) {
      // Update the field if the row is already being tracked
      editedRow[field] = event.target.value;
    } else {
      // Add new edited row data to editedData array
      const newEdit = { id: row.id, [field]: event.target.value };
      this.editedData.push(newEdit);
    }

    // Update shared edited data
    this.dataSharingService.setEditedData(this.editedData);
    this.dataSharingService.updatePosition(position);
  }
}
